import { Trello as TrelloIcon, PieChart as PieChartIcon } from 'react-feather';

import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import ReceiptIcon from '@material-ui/icons/Receipt';

import { MODULE } from 'src/config';

export const navConfig = [
  {
    moduleName: '/servico',
    nav: [
      {
        subheader: 'Gereciamento de Equipe',
        items: [
          {
            title: 'Kanban',
            href: `${MODULE.servicos.location}/kanban`,
            icon: TrelloIcon,
          },
        ],
      },
    ],
  },
  {
    moduleName: '/industria',
    nav: [
      {
        subheader: 'INDÚSTRIA',
        items: [
          {
            title: 'Dashboard',
            icon: PieChartIcon,
            href: `${MODULE.industria.location}/dashboard`,
          },
          {
            title: 'Leitor de produção',
            icon: CenterFocusStrongIcon,
            href: `${MODULE.industria.location}/leitor-producao`,
          },
          {
            title: 'Movimentos de produção',
            icon: SyncAltIcon,
            href: `${MODULE.industria.location}/movimento-producao`,
          },
        ],
      },
    ],
  },
  {
    moduleName: '/cliente',
    nav: [
      {
        subheader: 'ÁREA FINANCEIRA',
        items: [
          {
            title: 'Boletos',
            icon: ReceiptIcon,
            href: `${MODULE.cliente.location}/boletos`,
          },
        ],
      },
    ],
  },
];
